import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengSharedModule, HvlNgSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { HrPerOrgUnitPosPickerComponent } from './hr-per-org-unit-pos-picker.component';

@NgModule({
    declarations: [HrPerOrgUnitPosPickerComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TranslateModule,
        HvlFormItemModule,
    ],
    exports: [HrPerOrgUnitPosPickerComponent],
})
export class HrPerOrgUnitPosPickerModule {}
